import { createSlice } from "@reduxjs/toolkit";

export const DuplicateTimeSlotSlice = createSlice({
    name: "duplicateTimeSlots",
    initialState: {
        duplicateTimeSlots: null
    },
    reducers: {
        setDuplicateTimeSlots: (state, action) => {
            state.duplicateTimeSlots = action.payload;
        },
        clearDuplicateTimeSlots: (state, action) => {
            state.duplicateTimeSlots = null;
        }
    }
})

export const { setDuplicateTimeSlots, clearDuplicateTimeSlots } = DuplicateTimeSlotSlice.actions;

export default DuplicateTimeSlotSlice.reducer;




